export class ApplicationConfiguration {
    applicationUri!: string;
    appId!: string;
    appName!: string;
    stage!: string;
    prefix!: string;
    tenant!: string;

    azureB2c!: {
        instance: string;
        domain: string;
        signUpSignIn: string;
        resetPassword: string;
        editProfile: string;
        switchTenant?: string;
    };
}